module.exports = __webpack_public_path__ + "static/logo-a0d558f049125eeb44107709f373f2c6.png";